import { conversationHomeModuleQuery, useModule } from 'system/structure-modules';

export default function SiloIndexScreen() {
    const { ConversationHomeScreen } = useModule(conversationHomeModuleQuery);
    return <ConversationHomeScreen />;
}
